/**
 * @flow
 * @relayHash 0cbffafcc265c462a69f16b2e2f8319c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type FeeTemplateLoaderFragment_viewer$ref = any;
export type FeeTemplateLoaderQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  search?: ?string,
|};
export type FeeTemplateLoaderQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: FeeTemplateLoaderFragment_viewer$ref
  |}
|};
export type FeeTemplateLoaderQuery = {|
  variables: FeeTemplateLoaderQueryVariables,
  response: FeeTemplateLoaderQueryResponse,
|};
*/


/*
query FeeTemplateLoaderQuery(
  $first: Int
  $offset: Int
  $search: String
) {
  viewer {
    ...FeeTemplateLoaderFragment_viewer_2pFftX
    id
  }
}

fragment FeeTemplateLoaderFragment_viewer_2pFftX on Query {
  feeTemplates(first: $first, offset: $offset, search: $search) {
    edges {
      node {
        id
        name
        createdAt
        updatedAt
        description
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FeeTemplateLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "FeeTemplateLoaderFragment_viewer",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "FeeTemplateLoaderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "feeTemplates",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "FeeTemplateNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "FeeTemplateNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FeeTemplateNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "updatedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "description",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "FeeTemplateLoaderQuery",
    "id": null,
    "text": "query FeeTemplateLoaderQuery(\n  $first: Int\n  $offset: Int\n  $search: String\n) {\n  viewer {\n    ...FeeTemplateLoaderFragment_viewer_2pFftX\n    id\n  }\n}\n\nfragment FeeTemplateLoaderFragment_viewer_2pFftX on Query {\n  feeTemplates(first: $first, offset: $offset, search: $search) {\n    edges {\n      node {\n        id\n        name\n        createdAt\n        updatedAt\n        description\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cf972e8a7f60ea646ad33cf2d69fcc24';
module.exports = node;
